import { AxiosResponse } from 'axios';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import http from '../config/http-common';

export interface VersionInfoModel {
  componentName: string;
  componentVersion: string;
  componentBuildDate: string;
}

export interface AppInfoModel {
  gatewayVersionInfos: VersionInfoModel[];
  datapoolVersionInfos: VersionInfoModel[];
}

export const useInfoStore = defineStore('info', () => {
  const appInfoModel = ref({} as AppInfoModel);
  const error = ref<Error | unknown>(null);

  const fetchAppInfo = async () => {
    try {
      const response: AxiosResponse<AppInfoModel> = await http.get('/appinfo');
      appInfoModel.value = response.data;
    } catch (err) {
      error.value = err;
    }
    return appInfoModel;
  };

  return {
    fetchAppInfo: fetchAppInfo,
    error,
  };
});
